import script from "./InvestigationBillAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestigationBillAdd.vue?vue&type=script&setup=true&lang=js"

import "./InvestigationBillAdd.vue?vue&type=style&index=0&id=243bd18d&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-243bd18d"]])

export default __exports__